import { render, staticRenderFns } from "./myCourse.vue?vue&type=template&id=5cd67ce9&scoped=true&"
import script from "./myCourse.vue?vue&type=script&lang=js&"
export * from "./myCourse.vue?vue&type=script&lang=js&"
import style0 from "./myCourse.vue?vue&type=style&index=0&id=5cd67ce9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd67ce9",
  null
  
)

export default component.exports